<div class="cs-cb-gooey">
  <div class="blobs">
    <div class="blob-center"></div>
    <div class="blob"></div>
    <div class="blob"></div>
    <div class="blob"></div>
    <div class="blob"></div>
    <div class="blob"></div>
    <div class="blob"></div>
  </div>
  
</div>

<style lang="scss">
  @use './../../../../scss/components/themes/loading-theme/loading-gooey-theme';
</style>
